<template>
  <div class="card" id="addNew">
    <b-card-header class="border-0">
      <div class="d-flex align-items-center">
        <h5 class="card-title mb-0 flex-grow-1">维修信息</h5>
      </div>
    </b-card-header>
    <b-card-body class="border-top">
      <!-- 第一行 -->
      <b-row>
        <b-col xxl="6">
          <label for="weight-field" class="form-label">
            <span>客户</span>
            <span class="text-danger">（必填）</span>
          </label>
          <Multiselect
            v-model="form.customer"
            :close-on-select="true"
            :searchable="true"
            label="name"
            value-prop="id"
            :options="customerOptions"
            placeholder="公司名称"
            :class="{
              'is-invalid': submitted && v$.form.customer.$error,
            }"
            required
          />
          <div
            v-for="(item, index) in v$.form.customer.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col xxl="6">
          <label for="weight-field" class="form-label">
            <span>维修地址</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="维修地址"
            v-model="form.device_location"
          />
        </b-col>
      </b-row>
      <!-- 第二行 -->
      <b-row class="mt-4">
        <b-col xxl="3">
          <label for="weight-field" class="form-label">
            <span>泵头序列号</span>
            <span class="text-danger">（必填）</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="泵头序列号"
            v-model="form.number"
            :class="{
              'is-invalid': submitted && v$.form.number.$error,
            }"
            required
          />
          <div
            v-for="(item, index) in v$.form.number.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col xxl="3">
          <label for="weight-field" class="form-label">
            <span>期望服务时间</span>
            <span class="text-danger">（必填）</span>
          </label>
          <flat-pickr
            v-model="form.expectation_at"
            placeholder="请选择时间"
            :config="dateconfig"
            class="form-control"
            :class="{
              'is-invalid': submitted && v$.form.expectation_at.$error,
            }"
            required
          ></flat-pickr>
          <div
            v-for="(item, index) in v$.form.expectation_at.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col xxl="3">
          <label for="weight-field" class="form-label">
            <span>联系电话</span>
            <span class="text-danger">（必填）</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="联系电话"
            v-model="form.customer_contact_number"
            :class="{
              'is-invalid': submitted && v$.form.customer_contact_number.$error,
            }"
            required
          />
          <div
            v-for="(item, index) in v$.form.customer_contact_number.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col xxl="3">
          <label for="weight-field" class="form-label">
            <span>联系人</span>
            <span class="text-danger">（必填）</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="联系人"
            v-model="form.customer_contact"
            :class="{
              'is-invalid': submitted && v$.form.customer_contact.$error,
            }"
            required
          />
          <div
            v-for="(item, index) in v$.form.customer_contact.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
      </b-row>
      <!-- 紧急程度 -->
      <b-row class="mt-4">
        <b-col xxl="3">
          <label for="weight-field" class="form-label">
            <span>紧急程度</span>
            <span class="text-danger">（必填）</span>
          </label>
          <div class="d-flex priority-btn">
            <div
              v-for="(list, index) in priorityList"
              :key="index"
              :class="[
                'priority-common cursor-pointer',
                `priority-${list.value}`,
                currentChoose == index && 'active',
              ]"
              @click="handlerChoosepriority(index, list.value)"
            >
              <div class="btn-text">{{ list.label }}</div>
            </div>
          </div>
          <div class="priority-error" v-if="show_priority_error">
            紧急程度是必填项
          </div>
        </b-col>
      </b-row>
      <!-- 工单内容 -->
      <b-row class="mt-4">
        <b-col>
          <label for="weight-field" class="form-label">
            <span>工单内容</span>
          </label>
          <textarea type="text" class="form-control" v-model="form.content" />
        </b-col>
      </b-row>
      <!-- 附件 -->
      <b-row class="mt-4">
        <b-col>
          <UploadFiles
            input-file-id="filesUpload"
            title="附件"
            :files="files"
            :showFileList="showFileList"
            @changed="filesUpload"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </div>
  <div class="submit-btn position-relative text-end mt-4">
    <button
      type="button"
      class="btn btn-outline-primary waves-effect waves-light btn-common me-4"
      @click="handlerClose"
    >
      取消
    </button>
    <button
      type="button"
      class="btn btn-primary waves-effect waves-light btn-common"
      @click="handlerSubmit"
    >
      提交
    </button>
  </div>
  <message-alert
    :alertInfo="alertInfo"
    v-if="formValidataAlert"
  ></message-alert>
</template>

<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import UploadFiles from "@/views/widgets/upload-files";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import {
  getCustomerList,
  postRepairService,
  getUploadFileSign,
  putFiles,
  getUploadFileDetail,
  postUpdateFile,
  deleteFile,
} from "@/service/index";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    form: {
      customer: {
        required: helpers.withMessage("公司名称是必选项", required),
      },
      number: {
        required: helpers.withMessage("泵头序列号是必填项", required),
      },
      customer_contact_number: {
        required: helpers.withMessage("期望服务时间是必选项", required),
      },
      expectation_at: {
        required: helpers.withMessage("联系电话是必填项", required),
      },
      customer_contact: {
        required: helpers.withMessage("联系人是必填项", required),
      },
    },
  },
  data() {
    return {
      submitted: false,
      showFileList: false,
      alertInfo: {
        variant: "danger",
        content: "",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      form: {
        customer: "",
        device_location: "",
        number: "",
        expectation_at: "",
        customer_contact_number: "",
        customer_contact: "",
        priority: "",
        content: "",
        attachment: [],
        type: "1",
      },
      files: [],
      dateconfig: {
        wrap: true,
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      customerOptions: [],
      priorityList: [
        {
          label: "不紧急",
          value: "1",
        },
        {
          label: "紧急",
          value: "2",
        },
        {
          label: "非常紧急",
          value: "3",
        },
      ],
      currentChoose: null,
      show_priority_error: false,
    };
  },
  mounted() {
    this.initCustomer();
  },
  watch: {
    "form.customer"(val) {
      this.customerOptions.forEach((customer) => {
        if (customer.id == val) {
          this.form.device_location = customer.address;
        }
      });
    },
    "form.priority"(val) {
      if (val) {
        this.show_priority_error = false;
      }
    },
  },
  methods: {
    initCustomer() {
      getCustomerList({ page_size: 0 }).then((res) => {
        if (res && res.payload && res.payload.results) {
          this.customerOptions = res.payload.results;
        }
      });
    },
    filesUpload(file, type) {
      if (!file) {
        return;
      }
      if (type == "add") {
        this.updateFiles(file[0], type);
      } else {
        this.updateFiles(file, type);
      }
    },
    /* 上传文件 */
    updateFiles(file, type) {
      if (type == "add") {
        let filename = file.name;
        let objectName = `repair/${uuidv4()}/${filename}`;
        let signParams = {
          object: objectName,
          method: "upload",
        };
        getUploadFileSign(signParams).then((sign) => {
          if (sign && sign.payload) {
            putFiles(sign.payload.signedUrl, file, file.type).then(() => {
              let detailOption = {
                object: objectName,
              };
              getUploadFileDetail(detailOption).then((detail) => {
                if (detail && detail.payload) {
                  let info = {
                    url: detail.payload.url,
                    etag: detail.payload.etag,
                    size: detail.payload.size,
                    content_type: detail.payload.contentType,
                    object_name: detail.payload.objectName,
                    last_modified: detail.payload.lastModified,
                  };
                  postUpdateFile(info).then((post) => {
                    if (post && post.payload) {
                      this.showFileList = true;
                      let file = _.cloneDeep(post.payload);
                      file.name = filename;
                      this.files.push(file);
                      this.form.attachment.push(file.id);
                      this.formValidataAlert = true;
                      this.alertInfo = {
                        variant: "success",
                        content: this.$t("base.upload_success"),
                        icon: "ri-alert-line",
                      };
                      setTimeout(() => {
                        this.formValidataAlert = false;
                      }, 3000);
                    }
                  });
                }
              });
            });
          }
        });
      } else {
        let params = { object: file.object_name };
        deleteFile(params).then((res) => {
          if (res && res.payload) {
            document.querySelector("#filesUpload").value = "";
            this.files = this.files.filter((f) => {
              return f.object_name != file.object_name;
            });
            this.formValidataAlert = true;
            this.alertInfo = {
              variant: "success",
              content: this.$t("base.delete_success"),
              icon: "ri-alert-line",
            };
            setTimeout(() => {
              this.formValidataAlert = false;
            }, 3000);
          }
        });
      }
    },
    handlerChoosepriority(index, value) {
      this.currentChoose = index;
      this.form.priority = value;
    },
    handlerSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      if (!this.form.priority) {
        this.show_priority_error = true;
        return;
      }

      let params = _.cloneDeep(this.form);
      console.log(params);
      params.customer = Number(params.customer);
      postRepairService(params)
        .then((res) => {
          if (res && res.payload) {
            this.formValidataAlert = true;
            this.alertInfo = {
              variant: "success",
              content: this.$t("base.submit_success"),
              icon: "ri-alert-line",
            };
            setTimeout(() => {
              this.formValidataAlert = false;
              this.$router.push({
                path: "/repair-request",
              });
            }, 3000);
          }
        })
        .catch(() => {
          this.formValidataAlert = true;
          this.alertInfo = {
            variant: "danger",
            content: this.$t("base.submit_failed"),
            icon: "ri-alert-line",
          };
          setTimeout(() => {
            this.formValidataAlert = false;
          }, 3000);
        });
    },
    handlerClose() {
      this.$router.push({
        path: "/repair-request/list",
      });
    },
  },
  components: {
    UploadFiles,
  },
};
</script>

<style scoped lang="scss">
#addNew {
  width: 60%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 100px;
}
.priority-common {
  border: 1px solid;
  text-align: center;
  .btn-text {
    padding: 8px 10px;
    min-width: 100px;
  }
}
.priority-1 {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  color: #0ab39c;
  &.active {
    background-color: #0ab39c;
    color: #fff;
  }
}
.priority-2 {
  color: #f7b84b;
  &.active {
    background-color: #f7b84b;
    color: #fff;
  }
}
.priority-3 {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #ed5e5e;
  &.active {
    background-color: #ed5e5e;
    color: #fff;
  }
}
.priority-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f06548;
}
.submit-btn {
  width: 60%;
  left: 50%;
  transform: translateX(-50%);
}
</style>
